import {
	PagedMultiSelectField,
	PagedSingleSelectField,
	laravelSelectFetchConfig,
	laravelServiceSelectFetchConfig,
} from "@dgs/core";
import { FC } from "react";
import { UserSelectOption } from "../../../shared/ui/UserSelectOption";
import { userService } from "../shared/api/userService";
import { UserOptionsResource } from "../shared/types";

interface Props {
	name: string;
	label: string;
	clearable?: boolean;
	projectManagerType?: string;
}

export const getLabel = (user: UserOptionsResource) => user.name;

export const UserSelectField: FC<Props> = ({ name, label, clearable = false, projectManagerType }) => {
	return (
		<PagedSingleSelectField
			name={name}
			label={label}
			getLabel={getLabel}
			clearable={clearable}
			fetchConfig={laravelSelectFetchConfig(userService.optionsKey, (search, page) =>
				userService.options(search, page, { projectManagerType }).then((r) => r.data),
			)}
		/>
	);
};

const fetchConfig = laravelServiceSelectFetchConfig(userService);

interface Props {
	name: string;
	label: string;
	required?: boolean;
	disabled?: boolean;
	description?: string;
}

export const UserMultiSelectField: FC<Props> = (props) => {
	return (
		<PagedMultiSelectField
			{...props}
			fetchConfig={fetchConfig}
			getLabel={getLabel}
			renderOption={(x, isSelected) => <UserSelectOption isSelected={isSelected} user={x} />}
		/>
	);
};

const fetcherWithDevices = (search: string, page: number) =>
	userService.optionsWithDevices(search, page).then((x) => x.data);

export const UserWithDevicesMultiSelectField: FC<Props> = (props) => {
	return (
		<PagedMultiSelectField
			{...props}
			fetchConfig={laravelSelectFetchConfig(userService.optionsWithDevicesKey, fetcherWithDevices)}
			getLabel={getLabel}
		/>
	);
};
